/**
 * FctListHeader — cabecera de listado con el patrón canónico GCvsc.
 *
 * Layout en una sola fila flex, con dos zonas:
 *  - izquierda (opcional): controles de acción, filtros adicionales, etc.
 *  - derecha: búsqueda, filtros principales, botón "Actualizar".
 *
 * El componente sólo proporciona el contenedor; el consumidor pasa los
 * controles concretos como children (zona derecha) o como `leftContent`
 * (zona izquierda).
 *
 * Uso típico:
 *
 *   <FctListHeader>
 *     <Input
 *       placeholder="Buscar..."
 *       prefix={<SearchOutlined />}
 *       style={{ width: 300 }}
 *       allowClear
 *     />
 *     <FctEstadoSegmented value={...} onChange={...} counts={...} />
 *     <Button icon={<ReloadOutlined />} loading={loading}>Actualizar</Button>
 *   </FctListHeader>
 *
 * Con contenido a la izquierda (separador automático que empuja la derecha):
 *
 *   <FctListHeader
 *     leftContent={
 *       <>
 *         <Select ... />
 *         <Button type="primary">Procesar todos</Button>
 *       </>
 *     }
 *   >
 *     <Input ... />
 *     <Button icon={<ReloadOutlined />}>Actualizar</Button>
 *   </FctListHeader>
 */

import React from 'react';

interface FctListHeaderProps {
  /** Controles para la zona izquierda. */
  leftContent?: React.ReactNode;
  /** Controles para la zona derecha (lo más común). */
  children?: React.ReactNode;
  /** Margen inferior. Por defecto 16. */
  marginBottom?: number;
}

export const FctListHeader: React.FC<FctListHeaderProps> = ({
  leftContent,
  children,
  marginBottom = 16,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 16,
        alignItems: 'center',
        justifyContent: leftContent ? 'flex-start' : 'flex-end',
        marginBottom,
      }}
    >
      {leftContent}
      {/* Spacer que empuja el contenido derecho cuando hay leftContent */}
      {leftContent && <div style={{ flex: 1 }} />}
      {children}
    </div>
  );
};
